var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66901 0.440338C8.87969 0.651276 8.99802 0.937212 8.99802 1.23534C8.99802 1.53346 8.87969 1.8194 8.66901 2.03034L2.71401 7.98534L8.66901 13.9403C8.77954 14.0433 8.86819 14.1675 8.92968 14.3055C8.99117 14.4435 9.02423 14.5925 9.0269 14.7436C9.02956 14.8946 9.00178 15.0447 8.94519 15.1847C8.88861 15.3248 8.80439 15.4521 8.69757 15.5589C8.59074 15.6657 8.46349 15.7499 8.32341 15.8065C8.18332 15.8631 8.03328 15.8909 7.88223 15.8882C7.73117 15.8856 7.5822 15.8525 7.4442 15.791C7.3062 15.7295 7.182 15.6409 7.07901 15.5303L0.32901 8.78034C0.118334 8.5694 0 8.28346 0 7.98534C0 7.68721 0.118334 7.40128 0.32901 7.19034L7.07901 0.440338C7.28995 0.229663 7.57588 0.111328 7.87401 0.111328C8.17214 0.111328 8.45807 0.229663 8.66901 0.440338Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.c721f64652bde885a5c16c6795f57ce6.svg";
export { ForwardRef as ReactComponent };